const TYPE_PREFIX = /^(CV|SOP|Contract)[_\s]+/i;
const GENERATED_SUFFIX = /[_\s]+\d+[_\s]+\d{8}[_\s]+\d{6}$/i;
const EXTENSION = /\.(pdf|docx?|txt)$/i;
const STORAGE_FILENAME_PATTERN =
  /^\d+_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

const TYPE_LABELS = {
  cv: 'CV',
  sop: 'Statement of Purpose',
  contract: 'Contract',
};

function decodeFilename(value) {
  let decoded = value;
  for (let i = 0; i < 2; i += 1) {
    try {
      const next = decodeURIComponent(decoded.replace(/\+/g, ' '));
      if (next === decoded) break;
      decoded = next;
    } catch {
      decoded = decoded
        .replace(/%20/gi, ' ')
        .replace(/%2E/gi, '.')
        .replace(/%2C/gi, ',')
        .replace(/%28/gi, '(')
        .replace(/%29/gi, ')')
        .replace(/%27/gi, "'")
        .replace(/%2D/gi, '-');
      break;
    }
  }
  return decoded;
}

function stripHtml(value) {
  return value
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
}

function basename(value) {
  const cleaned = value.split('?')[0] || value;
  const parts = cleaned.split(/[/\\]/);
  return parts[parts.length - 1] || cleaned;
}

function fallbackTitle(documentType) {
  return TYPE_LABELS[String(documentType || '').toLowerCase()] || 'Document';
}

function isStorageFilename(value) {
  return STORAGE_FILENAME_PATTERN.test(String(value || '').trim());
}

/**
 * Pick a readable title from a document record (prefers original upload name).
 */
export function getDocumentDisplayName(doc) {
  const candidates = [doc?.original_filename, doc?.filename]
    .map((name) => (typeof name === 'string' ? name.trim() : ''))
    .filter(Boolean);

  for (const name of candidates) {
    if (!isStorageFilename(name)) {
      return formatDocumentDisplayName(name, {
        documentType: doc?.document_type,
      });
    }
  }

  return fallbackTitle(doc?.document_type);
}

/**
 * Turn stored filenames / paths into readable titles for UI lists.
 */
export function formatDocumentDisplayName(rawName, { documentType } = {}) {
  if (!rawName || typeof rawName !== 'string') {
    return fallbackTitle(documentType);
  }

  if (isStorageFilename(rawName)) {
    return fallbackTitle(documentType);
  }

  let name = stripHtml(decodeFilename(basename(rawName.trim())));
  name = name.replace(EXTENSION, '');
  name = name.replace(GENERATED_SUFFIX, '');
  name = name.replace(TYPE_PREFIX, '');
  name = name.replace(/_/g, ' ');
  name = name.replace(/\s+/g, ' ').trim();

  if (!name) {
    return fallbackTitle(documentType);
  }

  return name;
}

export default formatDocumentDisplayName;
